import React, { FC } from 'react';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import { UserName } from '../name_component/user/UserNameComponent';
import { showDate, showHour } from '../../utils/DataFormatterUtils';
import { ProtectedImageThumbnails } from '../protected_image_thumbnails/ProtectedImageThumbnails';
import {
	NOTE_TYPE_SERVICE_CALL_CHECK_IN,
	NOTE_TYPE_SERVICE_CALL_CHECK_OUT,
} from '../../constants/NoteTypes';

interface ServiceCallLogEntryProps {
	entry: any;
	type: typeof NOTE_TYPE_SERVICE_CALL_CHECK_IN | typeof NOTE_TYPE_SERVICE_CALL_CHECK_OUT;
}

const ServiceCallLogEntry: FC<ServiceCallLogEntryProps> = ({ entry, type }) => {
	const isCheckIn = type === NOTE_TYPE_SERVICE_CALL_CHECK_IN;

	const contact = isCheckIn
		? nullSafeGet('checkInByContact', entry)
		: nullSafeGet('checkOutByContact', entry);
	const time = isCheckIn ? nullSafeGet('checkInTime', entry) : nullSafeGet('checkOutTime', entry);
	const notes = isCheckIn
		? nullSafeGet('checkInNotes', entry)
		: nullSafeGet('checkOutNotes', entry);
	const imagesWithCaption = isCheckIn
		? nullSafeGetOrElse('checkInImagesWithCaption', entry, [])
		: nullSafeGetOrElse('checkOutImagesWithCaption', entry, []);

	const imageKeys = imagesWithCaption
		.map(function (img) {
			return nullSafeGet('s3ObjectKey', img);
		})
		.filter(Boolean);

	const label = isCheckIn ? 'Service Call Started' : 'Service Call Ended';

	return (
		<div
			style={{ maxWidth: '80%' }}
			className="mx-auto flex flex-col items-center justify-center text-center"
		>
			<div className="flex flex-row flex-wrap items-center justify-center">
				<span className="font-medium">{label}</span>
				{notes ? <span className="mx-1 italic text-gray-400">- "{notes}"</span> : null}
				<div className="ml-2 flex flex-row items-center">
					{contact ? (
						<UserName
							mode="inline"
							contact={contact}
							underline={false}
							showAvatar
							showNameWithAvatar
						/>
					) : null}
					<span className="mx-2 text-2xl text-gray-500">&middot;</span>
				</div>
				<div className="text-gray-400">
					{showDate(time, 'MMM DD')} {showHour(time, 'MMM DD')}
				</div>
			</div>
			{imageKeys.length > 0 ? (
				<div className="mt-2">
					<ProtectedImageThumbnails imageWidth={120} imageHeight={120} photoStrings={imageKeys} />
				</div>
			) : null}
		</div>
	);
};

export default ServiceCallLogEntry;
